import ImageContainer from "@components/imageContainer";
import {
  Container,
  CardWrapper,
  CardContent,
  CardTitle,
  CardDescription,
  ImageWrapper,
  RatingDistanceWrapper,
  BadgesContainer,
  Badge,
  MakeListContainer,
  MakeItem
} from "./styles";
import { executeActions } from "@utils/index";

const AckoGarageList = (props: any) => {
  let {
    garageDetails: { entities },
    makeList = [],
    selectedMake,
    selectedPincode
  } = props;

  const { actions } = props;
  const { on_click } = actions || {};

  return (
    <Container>
      <MakeListContainer>
      <MakeItem
          isSelected={selectedMake === null || selectedMake === undefined || selectedMake === ""}
          onClick={() =>
            executeActions(on_click, {
              data: {
                make: null,
                pincode: selectedPincode
              }
            })
          }
        >
          All
        </MakeItem>
        {makeList?.map((make) => (
          <MakeItem
            key={make.id}
            isSelected={selectedMake === make.id}
            onClick={() =>
              executeActions(on_click, {
                data: {
                  make: make.id,
                  pincode: selectedPincode
                }
              })
            }
          >
            <ImageContainer
              imgSrc={make.logo}
              alt={make.name}
              width={28}
              height={28}
            />
          </MakeItem>
        ))}

      </MakeListContainer>
      {entities?.map((entity) => (
        <Card key={entity.id} entity={entity} />
      ))}
    </Container>
  );
};

const Card = (props) => {
  const { entity } = props;
  const {
    name,
    rating,
    distance,
    metadata: { address, display_name, legal_name, display_address }
  } = entity;
  const renderRatingAndDistance = () => {
    const ratingText = rating ? `${rating} rated` : "4.5 rated";
    const distanceText = distance ? `${distance} km` : "";
    return `${ratingText} ${ratingText && distance ? " | " : ""} ${distanceText}`;
  };
  return (
    <CardWrapper>
      <CardContent>
        <CardTitle>{name || display_name || legal_name}</CardTitle>
        <RatingDistanceWrapper>
          <ImageContainer
            imgSrc={"/images/full_star.svg"}
            alt="rating"
            width={12}
            height={12}
            isResolvePath={true}
          />
          &nbsp;{renderRatingAndDistance()}
        </RatingDistanceWrapper>
        <CardDescription>{address || display_address}</CardDescription>
        <BadgesContainer>
          <Badge>Live updates</Badge>
          <Badge>1-year warranty</Badge>
        </BadgesContainer>
      </CardContent>
      {/* <ImageWrapper>
        <ImageContainer
          imgSrc={"/images/sampleDealership.svg"}
          alt="carIcons"
          width={75}
          height={75}
          isResolvePath={true}
          styles={{
            borderRadius: "8px"
          }}
        />
      </ImageWrapper> */}
    </CardWrapper>
  );
};

export default AckoGarageList;
